// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"B5x52zLX","styledTabLines":"AjKL9gon","tabsContentWrapper":"Zex0NMX0","toggleWrapper":"pIfYFxrE","itemText":"djJE2_8t","bottomBar":"aNeBjjF0"};